<span
  [ngClass]="{
    title: isTitle,
    extra_info: isExtraInfo,
    text: isTitle && isExtraInfo
  }"
  [style.fontSize.px]="fontsize"
  >{{ text }}</span
>
